import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchCategories } from '../api/client';
import './CategoryPills.css';

export default function CategoryPills({ activeCategory = 'All', onSelect }) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['categories'],
    queryFn: fetchCategories,
  });

  const categories = ['All', ...(data?.categories?.map(c => c.name) || [])];

  if (isLoading) {
    return (
      <div className="category-pills-container">
        <div className="category-pills" style={{ opacity: 0.5 }}>
          <div className="pill active">All</div>
          <div className="pill">Loading...</div>
        </div>
      </div>
    );
  }

  if (isError) {
    return null; // hide gracefully on error
  }

  return (
    <div className="category-pills-container">
      <div className="category-pills">
        {categories.map(cat => (
          <button
            key={cat}
            className={`pill ${activeCategory === cat ? 'active' : ''}`}
            onClick={() => onSelect && onSelect(cat)}
          >
            {cat}
          </button>
        ))}
      </div>
    </div>
  );
}
